<template>
  <BusinessList :tabPanelData="tabList" :showStateFilter="true" :mainPage="true" :defaultActiveTab="9" pageTypeIn="BUSINESS" />
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import BusinessList from '@/views/business/businessList/components/BusinessTable.vue'

export default defineComponent({
  name: 'Businesslist',
  components: {
    BusinessList
  },
  setup() {
    const dataMap = reactive({
      tabList: [
        { name: '出库成本', id: 9 },
        { name: '联系人', id: 1 },
        { name: '工程师', id: 2 },
        { name: '市场费', id: 4 },
        { name: '外包费', id: 8 },
        // { name: '收款明细', id: 5 },
        // { name: '物流信息', id: 6 },
        // { name: '发票号码', id: 7 },
        { name: '跟踪信息', id: 3 }
      ]
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
